import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {MultipleSelectFilterModule} from '../../../../../core/component/multiple-select-filter/multiple-select-filter.module';
import {DocumentMultipleSelectFilterComponent} from './document-multiple-select-filter.component';
import {NgModule} from '@angular/core';
import {TablerIconsModule} from "angular-tabler-icons";
import {DatetimeLabelModule} from "../../../../../core/component/date/datetime-label/datetime-label.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        MultipleSelectFilterModule,
        TablerIconsModule,
        DatetimeLabelModule,
    ],
    declarations: [
        DocumentMultipleSelectFilterComponent
    ],
    exports: [
        DocumentMultipleSelectFilterComponent
    ],
})
export class DocumentMultipleSelectFilterModule{}
